﻿import React from 'react';
import styled from 'styled-components';

import definitions from '../Style/LfStyleDefinitions';
import {mediaQuery, clearFix} from '../Style/cssHelpers';

export const ComparisonWrapper = styled.div`
    display: block;
    width: 100%;

    margin-top: 15px;
    margin-bottom: 20px;
    padding: 30px;
    border-radius: 5px;

    background-color: white;
    ${clearFix()}

    ${mediaQuery.medium(`
        padding: 20px;
        margin-bottom: 15px;
    `)}

    ${mediaQuery.small(`
        padding: 15px;
        margin-bottom: 15px;
    `)}
`;

export const LinkButton = styled.a`
    position: relative;
    display: inline-block;
    width: auto;

    margin-top: 30px;
    padding: 7px 20px 7px 20px;

    font-family: ${definitions.fonts.heading};
    font-size: 18px;
    font-weight: bold;
    color: white;

    ${mediaQuery.large(`
        font-size: 16px;
    `)}

    ${mediaQuery.medium(`
        margin-top: 0px;
        margin-bottom: 0px;
    `)}

    ${mediaQuery.small(`
        margin-top: 0px;
        margin-bottom: 0px;
    `)}

    ${mediaQuery.xxsmall(`
        padding: 7px 15px 7px 15px;
    `)}

    background-color: ${definitions.colors.green};

    transition: background-color 300ms ease-out;

    &:hover {
        text-decoration: none;
        color: white;
    }
`;

export const ActionButton = styled.button`
    position: relative;
    display: inline-block;
    width: auto;

    padding: 10px 20px 10px 20px;
    margin-right: 20px;

    font-family: ${definitions.fonts.heading};
    font-size: 18px;
    ${mediaQuery.large(`
        font-size: 16px;
    `)}

    font-weight: bold;
    color: white;

    ${mediaQuery.small(`
        margin: 0px 10px 10px 0px;
    `)}

    ${mediaQuery.xxsmall(`
        padding: 10px 15px 10px 15px;
    `)}

    background-color: ${definitions.colors.green};
    border-radius: 5px;

    transition: background-color 300ms ease-out;

    &:hover {
        text-decoration: none;
        color: white;
    }
`;
